import clsx from 'clsx';
import { Pill } from '../../../../shared/ui/pill/Pill';
import pillStyles from '../../../../shared/ui/pill/Pill.module.css';
import { MetaRow } from '../../../../shared/ui/meta-row';
import { OverflowPills } from '../../../../shared/ui/overflow-pills';
import { CAMPAIGN_CADENCES_TYPE_TAB_KEY } from '../../constants/campaignCadencesTabs';
import { formatTriggerSendCondition } from '../../lib/formatTriggerSendCondition';
import { CampaignCadenceCardPanel } from './CampaignCadenceCardPanel';
import { TemplateWarnings } from './TemplateWarnings';
import styles from './CampaignCadenceCard.module.css';

// Trigger templates are ordered by their send conditions, not by the editor, so this card has
// no drag handle, no step arrows and no move-to.
export function TriggerCadenceCard({ item, onPreview, onEdit }) {
  const { template } = item;
  const triggerEntries = Array.isArray(template.triggers) ? template.triggers : [];
  const triggerConditionName = triggerEntries[0]?.trigger?.name ?? '';
  const triggerDelays = triggerEntries.map((entry) => formatTriggerSendCondition(entry));

  return (
    <div className={clsx(styles.card, styles.cardFlat)}>
      <div className={clsx(styles.row)}>
        <CampaignCadenceCardPanel
          template={template}
          variant={CAMPAIGN_CADENCES_TYPE_TAB_KEY.TRIGGERS}
          showLanguageFlag
          onPreview={onPreview}
          onEdit={onEdit}
        />
      </div>

      {(triggerConditionName || triggerDelays.length > 0) && (
        <>
          {triggerConditionName && (
            <MetaRow
              label="Trigger Condition"
              className={clsx(styles.metaRowWrap)}
              labelClassName={clsx(styles.metaLabelWide)}
            >
              <Pill variant="grey">{triggerConditionName}</Pill>
            </MetaRow>
          )}
          {triggerDelays.length > 0 && (
            <MetaRow label="Send Condition" labelClassName={clsx(styles.metaLabelWide)}>
              <OverflowPills
                items={triggerDelays}
                wrapClassName={clsx(styles.metaPills)}
                pillClassName={clsx(pillStyles.pill, pillStyles.variantGrey, pillStyles.nowrap)}
                ariaLabel="Send Condition"
                maxRows={1}
                tooltipItemTransform={(value) => value.toUpperCase()}
              />
            </MetaRow>
          )}
        </>
      )}

      <TemplateWarnings warnings={template.warnings ?? []} />
    </div>
  );
}
